import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';
import UpdateAnnouncement from './UpdateAnnouncement';

function AnnouncementsDash({ showMessage, page_title }) {

    useEffect(() => {
            document.title = page_title;
        }, [page_title]);

    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState("view");

    const tabActivated = (tabName) => {
        navigate(`?tab=${tabName}`);
        if(tabName === "view"){
            setActiveTab("view");
            setShowUpdate(false);
        }else{
            setActiveTab("create");
        }
    };

    const [title, setTitle] = useState("");
    const [body, setBody] = useState("");
    const [date, setDate] = useState("");

    const [currentAnnouncementId, setCurrentAnnouncementId] = useState("");

    const submitAnnouncement = async () => {
        if (!title || !body) {
            showMessage("error", "Title and body are required.");
            return;
        }

        const formData = new FormData();
        formData.append('title', title);
        formData.append('body', body);
        formData.append('date', date); // allow empty, backend handles default

        try {
            const response = await fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=submitAnnouncement', {
                method: 'POST',
                credentials: "include",
                body: formData,
            });

            const data = await response.json();
            if (data.success) {
                showMessage("success", "Announcement submitted successfully!");
                reloadAnnouncement();
                tabActivated("view");
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                showMessage("error", data.error || "Submission failed.");
            }
        } catch (err) {
            showMessage("error", err.message);
        }
    };

    const reloadAnnouncement = () => {
        setTitle("");
        setBody("");
        setDate("");
    };

    useEffect(() => {
            fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=checkUserSession', {
                    method: 'GET',
                    credentials: "include",
                })
                .then(response => response.json())
                .then(data => {
                    if (data.success !== 'true') {
                        navigate("/dashboard/login")
                    }
                })
                .catch(error => {
                    console.log(error)
                });
    }, []);

    const dashLogout = () =>{
        fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=removeUserSession', {
                method: 'GET',
                credentials: "include",
            })
            .then(response => response.json())
            .then(data => {
                console.log(data)
                if (data.success === 'true') {
                    showMessage("success", "Logged Out!");
                    navigate("/dashboard/login")
                }
            })
            .catch(error => {
                showMessage("error", "Something went wrong.");
        });
    }


    //Show editors
    const [announcements, setAnnouncements] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=getAllAnnouncements")
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setAnnouncements(data.announcements);
                } else {
                    console.error("API Error:", data.error);
                }
            })
            .catch(error => console.error("Error fetching announcements:", error));
    }, []);


    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = announcements.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(announcements.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


    const deleteAnnouncement = async (announcementId) => {
        const confirmed = window.confirm("Are you sure you want to delete this announcement?");
        if (!confirmed) return;

        try {
            const response = await fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=deleteAnnouncement`, {
                method: 'POST',
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ id: announcementId }),
            });

            const data = await response.json();

            if (data.success) {
                showMessage("success", "Announcement deleted successfully.");
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                showMessage("error", data.error);
            }
        } catch (err) {
            showMessage("error", err.message);
        }
    };

    const [showUpdate, setShowUpdate] = useState(false);

    const updateAnnouncement = (announcementId) => {
        setCurrentAnnouncementId(announcementId);
        setShowUpdate(true);
    };

    const dashBack = () => {
        navigate("/dashboard");
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    return (
      <>
        <div className='dash_section'>
            <div className="dash_wrapper">

                <div className='dash_logout'>
                    <div className='dash_back_cta' onClick={() => dashBack()}>
                        Dashboard
                    </div>
                    <div className='dash_logout_cta' onClick={() => dashLogout()}>
                        Logout
                    </div>
                </div>

                <div className='dash_header_tabs'>
                    <div className='dash_header_tab' onClick={() => tabActivated('view')} style={activeTab === "view" ? { borderBottom: '2px solid gray' } : {}}>
                        View Announcements

                    </div>
                    <div className='dash_header_tab' onClick={() => tabActivated('create')} style={activeTab === "create" ? { borderBottom: '2px solid gray' } : {}}>
                        Add New Announcement
                    </div>
                </div>
                
                <div className='dash_body_tab' style={activeTab === "view" ? { display: 'block' } : {display: 'none'}}>
                    
                    {showUpdate === false ?
                    <div>

                        <h2 className='dash_body_title'>Announcements - View</h2>
                    
                        <div className='dash_table_wrapper'>
                            <div className='dash_table_body'>
                                {currentItems.map((announcement) => (
                                    <div key={announcement.id} className='dash_table_body_wrapper'>

                                        <p className='dash_table_info_education'><strong>ID:</strong> {announcement.id}</p>

                                        <div className='dash_table_info'>
                                            <div className='dash_table_info_content'>
                                                <p className='dash_table_ann_title'>{parse(announcement.title)}</p>
                                                <p className='dash_table_ann_date'><span className="fa-regular fa-calendar"></span> {formatDate(announcement.date)}</p>
                                                <p className='dash_table_ann_body'>{parse(announcement.body)}</p>
                                                
                                            </div>
                                            
                                        </div>


                                        <div className='dash_table_info_actions'>
                                            <button className='dash_table_info_action' onClick={()=> updateAnnouncement(announcement.id)}>Update</button>
                                            <button className='dash_table_info_action info_action_delete' onClick={()=>deleteAnnouncement(announcement.id)}>Delete</button>
                                        </div>    
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Pagination */}
                        <div style={{ marginTop: "1rem", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem" }}>
                            
                            {/* Left Arrow */}
                            <button
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                                style={{
                                    height: "40px",
                                    width:"40px",
                                    backgroundColor: "#eee",
                                    color: "#000",
                                    border: "none",
                                    borderRadius: "100px",
                                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                                    opacity: currentPage === 1 ? 0.5 : 1
                                }}
                            >
                                <span className="fa-solid fa-arrow-left"></span>
                            </button>

                            {/* Page Info */}
                            <span>
                                Page {currentPage} of {totalPages}
                            </span>

                            {/* Right Arrow */}
                            <button
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                style={{
                                    height: "40px",
                                    width:"40px",
                                    backgroundColor: "#eee",
                                    color: "#000",
                                    border: "none",
                                    borderRadius: "100px",
                                    cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                                    opacity: currentPage === totalPages ? 0.5 : 1
                                }}
                            >
                                <span className="fa-solid fa-arrow-right"></span>
                            </button>
                        </div>
                    </div>            
                     : 

                     <>
                        <h2 className='dash_body_title'>Announcements - Update Announcement</h2>

                        <UpdateAnnouncement id={currentAnnouncementId} showMessage={showMessage} setShowUpdate={setShowUpdate}/>
                     </>              
                    

                    }
                </div>

                <div className='dash_body_tab' style={activeTab === "update" ? { display: 'block' } : {display: 'none'}}>
                    <h2 className='dash_body_title'>Announcements - Update</h2>

                </div>

                <div className='dash_body_tab' style={activeTab === "create" ? { display: 'block' } : {display: 'none'}}>
                    <h2 className='dash_body_title'>Announcements - Add New Announcements</h2>


                    <div className='dash_update_records'>
                        <label>1. Title</label><br/>
                        <input 
                            className='dash_input' 
                            type="text" 
                            value={title} 
                            onChange={(e) => setTitle(e.target.value)} 
                        /><br/>

                        <label>2. Body</label><br/>
                        <textarea
                            className="dash_input"
                            value={body}
                            onChange={(e) => setBody(e.target.value)}
                            rows={5}
                        /><br/>

                        <label>3. Date (optional)</label><br/>
                        <input 
                            className='dash_input' 
                            type="date" 
                            value={date} 
                            onChange={(e) => setDate(e.target.value)} 
                        /><br/>

                        <br/><br/>
                        <div className='dash_buttons_wrapper'>
                            <button className='dash_form_buttom' onClick={submitAnnouncement}>Submit</button>
                            <button className='dash_form_buttom dash_reset' onClick={reloadAnnouncement}>Reset</button>
                        </div>
                    </div>

                </div>
                
                
            </div>
        </div>
      </>
    );
}

export default AnnouncementsDash;